export default {
  install(Vue) {
    Vue.money = value => {
      return formatMoney(value);
    };

    Vue.prototype.$money = function(value) {
      return formatMoney(value);
    };

    Vue.mixin({
      filters: {
        money(value) {
          return formatMoney(value);
        },
      },
    });
  },
};

function formatMoney(value) {
  if (!value) {
    return null;
  }

  if (typeof value === "object") {
    if (value.text) {
      return value.text;
    }

    if (value.amount) {
      return value.amount;
    }

    return null;
  }

  return value;
}
